module.exports = __webpack_public_path__ + "img/19.c76ea97c.png";